import {Injectable} from '@angular/core';
import * as replaceColor from 'replace-color';

@Injectable({
  providedIn: 'root'
})
export class ColorReplaceService {

  async changeColorImg(img: any, colorA?: string, colorB?: string) {
    if (colorA && colorB) {
      const object = await replaceColor({
        image: img,
        colors: {
          type: 'hex',
          targetColor: colorA,
          replaceColor: colorB
        },
        deltaE: 11
      });

      return object.getBase64Async('image/png');
    }
    return img;
  }
}
